<template>
  <div style="display: inline-flex">

    <Dialog :visible="visible" class="function-select-dialog" :modal="true" 
        :closable="true" :dismissableMask="true" :style="{width: '90vw', minWidth: '460px'}" :breakpoints="{'820px': '100vw'}" :draggable="false"
        @update:visible="updateVisible" >
        
      <template #header>{{$t('library.cycle.function_title')}}</template>

      <div class="">

        <vueper-slides ref="phases" class="no-shadow ex--center-mode"
        :visible-slides="5"
        :dragging-distance="70" 
        :slideMultiple="true"
        fixed-height="330px"
        :bullets="false"
        :bullets-outside="false"
        :touchable="$functions.isMobile()"
        :breakpoints="{ 1800: { visibleSlides: 4 }, 1400: { visibleSlides: 3 }, 1000: { visibleSlides: 2 }, 700: { visibleSlides: 1 } }"      
              >      

            <template #arrow-left>
              <img src="assets/irinox/icons/carousel_left.svg"   :alt="$t('common.previous')"/>
            </template>

            <template #arrow-right>
              <img src="assets/irinox/icons/carousel_right.svg"  :alt="$t('common.next')" />
            </template>

            <vueper-slide
                v-for="index in 16"
                :key="index"
                :title="index.toString()"
                :style="'background-color: white'" 
                >
              <template #content>
                <div class="p-m-2">
                  <div :class="['library-select-function p-d-flex p-flex-column p-text-center p-ai-center',{'function-disabled':functionNotSelectable(index-1)}]" 
                      @mouseup="functionSelected(index-1)" @mousedown="mousedown(index-1)" @mousemove="mousemove"
                      v-tooltip.bottom="{
                        value: $t('library.device_not_compatible'),
                        disabled: !functionNotSelectable(index-1),
                        escape: true,
                      }">
                    <div>
                      <span :class="'icon-mf_function_'+(index-1).toString().padStart(2, '0')"  style="font-size: 120px;" />
                    </div>
                    <div>
                      <span>{{$t('mf.functions.'+(index-1))}}</span>
                    </div>
                  </div>
                </div>
              </template>
            </vueper-slide>

          </vueper-slides>
          
      </div>

      <template #footer></template>
      
    </Dialog>

  </div>

</template>

<script>

import { VueperSlides, VueperSlide } from 'vueperslides';
import 'vueperslides/dist/vueperslides.css';

export default {
  emits: ['update:visible','select:function'],
  components: {
      VueperSlides, 
      VueperSlide,
    },
    props: {
      visible: Boolean,
      serialNumber: String,
      appliance: Object
    },
    data() {
        return {
          dialog: {
            functionSelect: false,
          },
          drag: false,
          mouseClickIndex: null,
        };
    },
    computed: {
    },
    watch: {
    },
    created() {
    },
    mounted() {
    },
    methods: {
      updateVisible(value) {
        this.$emit("update:visible", value);
      },
      mousedown(functionId) {
        this.drag = false;
        this.mouseClickIndex = functionId;
      },
      mousemove() {
        if(this.$functions.isMobile()) {
          this.drag = true;
        }
      },
      functionSelected(functionId) {
        if(!this.drag && this.mouseClickIndex==functionId && !this.functionNotSelectable(functionId)) {
          this.$emit("select:function", functionId);
        }
      },
      functionNotSelectable(functionId) {
        if(this.serialNumber && this.appliance) {
          if(this.appliance._package==null) {
            //Macchina senza package
            return true;
          } else if(this.appliance._package===1) {
            //Macchina essential
            if([0,1,2,13,14].includes(functionId)) {
              return false;
            } else {
              return true;
            }
          } else if(this.appliance._package===6) {
            //Macchina pro --> senza Essicazione (12)
            if([0,1,2,3,4,5,6,7,8,9,10,11,13,14,15].includes(functionId)) {
              return false;
            } else {
              return true;
            }
          } else {
            //Macchina excellence (pkg 5) --> Marinatura (15) solo se firmware >= v7.7
            const marinaturaThreshold = "v7.7";
            const fw = this.appliance?.currentSoftwareVersion ?? null;
            
            const marinaturaEnabled = fw !== null
              ? this.$functions.compareVersionStrings(fw, marinaturaThreshold) >= 0
              : false; // Conservativo se firmware sconosciuto
            
            const allowed = [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14];
            if (marinaturaEnabled) allowed.push(15);
            
            return !allowed.includes(functionId);
          }
        } else {
          return false;
        }
      }
    }
}
</script>

<style scoped>

</style>